import { Component, OnInit } from '@angular/core';
import { HelperService } from 'src/app/services/helper/helper.service';

@Component({
  selector: 'app-aside',
  templateUrl: './aside.component.html',
  styleUrls: ['./aside.component.scss'],
})
export class AsideComponent implements OnInit {
  selectEl: number | null = null;
  constructor(
    private helperService: HelperService
  ) {}
  userRoleStorage:string = this.helperService.getUserRoles()[0].authority;
  userRole:string = '';

  ngOnInit() {
    this.checkScreenWidth();
    window.addEventListener('resize', this.checkScreenWidth.bind(this));
   
    this.userRole= this.helperService.getUserRoles();

    console.log("Usuario: "+this.userRole);
  }

  isMobile = false;

  checkScreenWidth() {
    this.isMobile = window.innerWidth < 768; // Cambia el número según tu necesidad
  }
  selectItem(index:number){
    this.selectEl = index;
  }
  itemSelected(index:number){
    return this.selectEl === index;
  }

  
  identifyRole():void{
    switch(this.userRoleStorage){
      case "ROLE_ADMIN":{
        this.userRole = 'Administrador';
        break;
      }
      case "ROLE_WAITER":{
        this.userRole = 'Mozo';
        break;
      }
      case "ROLE_CASHIER":{
        this.userRole = 'Cajero';
        break;
      }
      case "ROLE_CHEF":{
        this.userRole = 'Cocinero';
        break;
      }
      default:{
        this.userRole = 'usuario';
        break;
      }
    }
  }
}
